export enum ContractTraceabilityStatus {
  Creation = 'En création',
  SignedBeneficiary = 'Signé bénéficiaire',
  ValidatedMetro = 'Validé Métropole',
  SignedMetro = 'Signé Métropole',
  Unvalidated = 'Invalidé - Retour référent',
  Done = 'Terminé',
}
